import {
	setUserData,
	initializeUserData,
	getUserCourseData
} from 'Assets/js/modules/user-utils';
export default function campusUtilityPanel() {
	const campusUtilityPanel = document.querySelector('.campus-utility-panel');
	if (!campusUtilityPanel) return;
	const fireButton = document.querySelector(
		'.campus-utility-panel__fire-button'
	);

	const superUsers = [9, 2, 4, 17, 4, 25, 42];
	if (superUsers.includes(Number(myUserData.id))) {
		campusUtilityPanel.classList.add('campus-utility-panel--visible');
		fireButton.addEventListener('click', async () => {
			console.log('clicking fire button...');

			const utilityPanelSelect = document.querySelector(
				'.campus-utility-panel__select'
			);
			const utilityPanelDataInput = document.querySelector(
				'.campus-utility-panel__input--data'
			);
			const utilityPanelPostIdInput = document.querySelector(
				'.campus-utility-panel__input--post-id'
			);
			const utilityPanelUserIdInput = document.querySelector(
				'.campus-utility-panel__input--user-id'
			);

			const selectedOption = utilityPanelSelect.selectedIndex;
			const selectedValue =
				utilityPanelSelect.options[selectedOption].value;
			switch (selectedValue) {
				case '1':
					let userId = Number(utilityPanelUserIdInput.value);
					console.log('getting user data...');
					async function run() {
						const userData = {user_id: userId};
						const user = await getUserCourseData(userData);
						console.log(user);
					}
					run();
					break;
				case '2':
					console.log('initializing user data...');
					const userIdInit = Number(utilityPanelUserIdInput.value);
					if (userIdInit) {
						const init = await initializeUserData({
							user_id: userIdInit
						});
					} else {
						console.log('No user ID provided');
					}
					break;
				case '3':
					console.log('saving user topic data...');
					const userIdTopic = Number(utilityPanelUserIdInput.value);
					const postId = Number(utilityPanelPostIdInput.value);
					const data = JSON.parse(utilityPanelDataInput.value);
					const newUserData = {
						post_type: 'topic',
						post_id: postId,
						post_data: data,
						user_id: userIdTopic
					};
					setUserData(newUserData);
					break;
				case '4':
					console.log('saving user module data...');
					const userIdModule = Number(utilityPanelUserIdInput.value);
					const postModuleId = Number(utilityPanelPostIdInput.value);
					const dataOb = JSON.parse(utilityPanelDataInput.value);
					const newUserModuleData = {
						post_type: 'module',
						post_id: postModuleId,
						post_data: dataOb,
						user_id: userIdModule
					};
					setUserData(newUserModuleData);
					break;
				case '5':
					console.log('saving user level data...');
					const userIdLevel = Number(utilityPanelUserIdInput.value);
					const postLevelId = Number(utilityPanelPostIdInput.value);
					const dataObLevel = JSON.parse(utilityPanelDataInput.value);
					const newUserLevelData = {
						post_type: 'level',
						post_id: postLevelId,
						post_data: dataObLevel,
						user_id: userIdLevel
					};
					setUserData(newUserLevelData);
					break;

				default:
					break;
			}
		});
	}
}
